import React, { useEffect, useRef } from "react";
import CartItem from "../cart/CartItem";
import Icon from "../../ui/Icon";
import { useCart } from "../../contexts/CartContext";
import EmptyCart from "../cart/EmptyCart";
import { loadStripe } from "@stripe/stripe-js";

function Cart() {
  const cartRef = useRef(null);
  const { cartOpen, setCartOpen, cartItems, price } = useCart();

  // Payment integration
  async function makePayment() {
    // console.log(cartItems);
    const stripe = await loadStripe(
      process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
        "pk_test_51PGFrWJ6PMMdl09hW6vOI0Gh5WtaaTY9HK6vLAp93IhDBiyFPEaRoXxJtjuCCsJ2YbgYZTJeFDxoGBylXpOzwbCG00LaTJg8WX",
    );

    const body = {
      products: cartItems,
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/create-checkout-session` ||
        "http://localhost:7500/api/create-checkout-session",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      },
    );

    const session = await response.json();
    // console.log(session);

    const result = stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) console.log(response.error);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (cartRef.current && !cartRef.current.contains(e.target))
        setCartOpen(false);
    }
    document.addEventListener("mousedown", handleClickOutside);

    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cartRef, setCartOpen]);

  return (
    <aside
      ref={cartRef}
      className={`min-w-md pointer-events-auto fixed right-0 top-0 z-30 h-screen bg-white px-4 py-16 text-lg text-black transition-all duration-300 md:px-20 ${cartOpen ? "translate-x-0 " : "translate-x-full"}`}
    >
      {/* Header */}
      <header className="mb-8 flex items-center justify-between">
        <span className="uppercase">
          {cartItems.length > 0 && `My cart (${cartItems.length})`}
        </span>
        <div onClick={() => setCartOpen(false)}>
          <Icon textColor="black">
            <ion-icon name="close-outline" size="large"></ion-icon>
          </Icon>
        </div>
      </header>

      <main className="flex h-full flex-col justify-between pb-8">
        {/* Items */}
        <ul
          className={`mb-8 h-3/4 ${cartItems.length > 0 ? "overflow-y-scroll" : "overflow-y-hidden"} `}
        >
          {cartItems.length > 0 &&
            cartItems.map((item, index) => (
              <CartItem key={index} item={item} />
            ))}

          {cartItems.length === 0 && <EmptyCart />}
        </ul>

        {/* Horizontal line, price and checkout button container */}
        <div>
          {/* Horizontal line */}
          <div className="mb-2">
            <hr className="border border-stone-400" />
          </div>

          {/* Price Container */}
          <div className="mb-4 flex items-center justify-between">
            <h3 className="uppercase">Grand Total:</h3>
            <div className="mb-2 text-3xl font-bold capitalize">{`€${cartItems.length === 0 ? "0" : `${price}`}.00`}</div>
          </div>

          {/* Checkout button */}
          <button
            className={`w-full py-3 text-lg uppercase text-white ${cartItems.length === 0 ? "cursor-not-allowed bg-[#777]" : "cursor-pointer bg-black"}`}
            onClick={makePayment}
          >
            Proceed to checkout
          </button>
        </div>
      </main>
    </aside>
  );
}

export default Cart;
